import { Button } from '@flos/react-ui';
import CallMeModal, { type CallMeModalProps } from '../CallMeModal/CallMeModal';
import { useState } from 'react';
import { useHippoText } from '../../hooks/useHippoText';
import { useRecoilValue } from 'recoil';
import { businessFlowSelector } from '../../recoil/selectors/getBusinessFlowSelector';
import { wizardStepAtom } from '../../recoil/atoms/wizardAtom';
import { pageName } from '../../config/wizardPagesConfig';

const CallMeButton = ({
    buttonText,
    isFloating = true
}: {
    buttonText?: string;
    isFloating?: boolean;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const [showModal, setShowModal] = useState(false);
    const businessFlow = useRecoilValue(businessFlowSelector);
    const wizardStep = useRecoilValue(wizardStepAtom);
    const getCallMeModalProps = (): CallMeModalProps => {
        let callMeProps: CallMeModalProps = {
            activityCode: 'dss_call_request',
            showModal,
            closeModal: () => {
                setShowModal(false);
            }
        };
        if (
            businessFlow === 'MPS' &&
            wizardStep &&
            ['MPSActivationPage', 'MPSAgreementStatusPage'].includes(pageName(wizardStep) ?? '')
        ) {
            callMeProps = {
                ...callMeProps,
                activityCode: 'dss_mps_payment_method',
                title: getHippoText('DSS-CALL-ME-MODAL-MPS-SUPPORT-HEADER'),
                description: getHippoText('DSS-CALL-ME-MODAL-MPS-SUPPORT-SUBHEADER')
            };
        }
        return callMeProps;
    };
    const callMeModalProps = getCallMeModalProps();

    return (
        <>
            <div
                className={
                    isFloating
                        ? 'u-floating-cta u-spacing-stack-bottom-10 u-spacing-stack-bottom-none@xs u-spacing-stack-right-12'
                        : ''
                }
            >
                <Button
                    onClick={() => {
                        setShowModal(true);
                    }}
                    theme={isFloating ? 'float' : 'primary'}
                >
                    {buttonText ?? getHippoText('DSS-COMMON-CALL-ME')}
                </Button>
            </div>
            {showModal && <CallMeModal {...callMeModalProps} />}
        </>
    );
};

export default CallMeButton;
